export default [
	{
		path: '/sga/cuadro-mando',
		name: 'cuadro_mando_sga',
		props: true,
		component: () => import(/* webpackChunkName: "sga" */ '../views/CuadroMandoSGA.vue')
	}
]
